<nb-card *ngIf="type == 'multiple'">
  <nb-card-header>
    <!-- <nb-alert status="danger">
      {{ message }}
    </nb-alert> -->

    <button
      type="submit"
      nbButton
      outline
      status="primary"
      size="small"
      [disabled]="loading"
      [class.btn-pulse]="loading"
      (click)="onClickBrowseFile()"
    >
      <nb-icon icon="image-outline"></nb-icon>
      Tải ảnh mới
    </button>

    <nb-alert *ngIf="message.length > 0" status="danger">
      {{ message }}
    </nb-alert>

    <nb-actions *ngIf="!done" size="small" class="see-more-button">
      <nb-action (click)="loadMore()">
        <nb-icon icon="more-horizontal-outline"></nb-icon>
        <span class="text-link">Xem thêm</span>
      </nb-action>
    </nb-actions>
  </nb-card-header>

  <!-- <nb-card-body [nbSpinner]="loading" nbSpinnerStatus="info">
    <ngx-view-gallery
      [mode]="'upload'"
      [imageObject]="imageObject"
      (onImageClick)="selectedImage($event)"
    >
    </ngx-view-gallery>
  </nb-card-body> -->

  <nb-card-body class="container" [nbSpinner]="loading" nbSpinnerStatus="info">
    <div class="row">
      <div class="column" *ngFor="let item of imageObject; let i = index">
        <!-- <nb-card>
          <nb-card-body>
            <ngx-view-image
              [imageURL]="item.thumbImage ? item.thumbImage : item.image"
              [size]="'small'"
            ></ngx-view-image>
          </nb-card-body>

          <nb-card-footer> </nb-card-footer>
        </nb-card> -->

        <img
          (click)="selectedImage(item.image)"
          [src]="item.thumbImage ? item.thumbImage : item.image"
          style="width: 100%"
        />
      </div>
    </div>
  </nb-card-body>
</nb-card>

<nb-card *ngIf="type != 'multiple'" [size]="size">
  <nb-card-header *ngIf="message.length > 0">
    <nb-alert status="danger">
      {{ message }}
    </nb-alert>
  </nb-card-header>

  <div class="grid-container">
    <div class="single-view">
      <div
        class="camera"
        [style.background-image]="'url(' + imageURL + ')'"
        (click)="onClickBrowseFile()"
        [nbSpinner]="loading"
        nbSpinnerStatus="warning"
        nbSpinnerSize="giant"
      ></div>
    </div>
  </div>
</nb-card>

<input
  type="file"
  #fileUpload
  id="fileUpload"
  name="fileUpload"
  accept="image/*"
  style="display: none"
/>
